exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".link-text[data-v-7b924f7a]{color:#409eff;text-decoration:none}.link-text[data-v-7b924f7a]:hover{text-decoration:underline}", "", {"version":3,"sources":["/workspace/src/views/batch-jobs/pages/AllBatchJobsTable.vue"],"names":[],"mappings":"AACA,4BAA4B,cAAc,oBAAoB,CAC7D,AACD,kCAAkC,yBAAyB,CAC1D","file":"AllBatchJobsTable.vue","sourcesContent":["\n.link-text[data-v-7b924f7a]{color:#409EFF;text-decoration:none\n}\n.link-text[data-v-7b924f7a]:hover{text-decoration:underline\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b924f7a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/batch-jobs/pages/AllBatchJobsTable.vue
// module id = 3290
// module chunks = 173